import { useState } from 'react';
import { faqs } from '@/mocks/galData';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[5fr_6fr]">
          <div>
            <span className="inline-block rounded-full bg-accent-100 px-4 py-1.5 text-sm text-accent-700">
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              入坑前想知道的，都在这里
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">
              从女主是谁、男主设定，到泡在我家的辣妹人物关系怎么理清，我们把新手最常问的几个问题整理出来，方便你快速上手、直接入坑。
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="#female-lead"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50 hover:bg-primary-600"
              >
                了解女主
              </a>
              <a
                href="#gallery"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-700"
              >
                查看角色图
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <span className="font-medium text-foreground-950">{faq.q}</span>
                    <i
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-primary-600 transition-transform ${
                        open ? 'rotate-45' : ''
                      }`}
                    >
                      <i className={open ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </i>
                  </button>
                  {open && (
                    <div className="px-5 pb-4">
                      <p className="text-sm leading-7 text-foreground-700">{faq.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}